// TODO(adobe-sign): Integration entry points for the full Adobe Sign implementation.
// All three steps run as a Vectr workflow — see docs/VECTR_INTEGRATION.md for the contract.
//   1. createAgreement   — POST to /api/vectr/adobe-sign/agreements (Vectr workflow trigger)
//   2. getSigningUrl     — Retrieve the Adobe Sign signing URL and redirect the signer
//   3. webhookHandler    — Receive AGREEMENT_COMPLETED callback from Adobe Sign via Vectr inbound webhook

import React from 'react'
import { Button } from '@/components/ui/Button'
import { Card } from '@/components/ui/Card'
import type { SignatureProvider, SigningSurfaceProps } from '../types'

const AdobeSignNotConfigured: React.FC<Pick<SigningSurfaceProps, 'onCancel'>> = ({ onCancel }) => (
  <Card className="p-6">
    <p className="text-sm text-muted-foreground mb-4">
      Adobe Sign is not configured. Set{' '}
      <code className="font-mono text-xs bg-muted px-1 py-0.5 rounded">
        VITE_ADOBE_SIGN_CLIENT_ID
      </code>{' '}
      to enable.
    </p>
    <div className="flex justify-end">
      <Button variant="outline" onClick={onCancel}>Cancel</Button>
    </div>
  </Card>
)

export const adobeSignProvider: SignatureProvider = {
  id: 'adobe-sign',
  displayName: 'Adobe Sign',
  available() {
    return Boolean(import.meta.env.VITE_ADOBE_SIGN_CLIENT_ID)
  },
  renderSigningSurface({ onCancel }: SigningSurfaceProps) {
    return <AdobeSignNotConfigured onCancel={onCancel} />
  },
}
